import { render } from "./ProjectCard3D.vue?vue&type=template&id=58d3a468"
import script from "./ProjectCard3D.vue?vue&type=script&lang=js"
export * from "./ProjectCard3D.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__